import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import lang from "../../../assets/lang/icons.json";
import FeaturesTemplate from "./FeaturesTemplate";

export default function Template13() {
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const [isEditing, setIsEditing] = useState(true);

  const uploadBanner = useSelector((state) => state.uploadBanner);
  const userData = useSelector((state) => state.user);
  const userStyle = useSelector((state) => state.userStyle);
  const userImages = useSelector((state) => state.userImages);

  const [bannerImageUrl, setBannerImageUrl] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");

  const [textColor, setTextColor] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [iconsThemeDefault, setIconsThemeDefault] = useState(false);
  const [fontSize, setFontSize] = useState("");
  const [linkColor, setLinkColor] = useState("");
  const [textname, setTextName] = useState("");
  const [imageUrl, setimageUrl] = useState("");

  const [imageSize, setImageSize] = useState("1");
  const [imageShape, setImageShape] = useState("square");
  const [iconSize, setIconSize] = useState("1");

  const standardColor = "#2e9aa4";

  const changeOtherFontSize = () => {
    if (fontSize === 1 || fontSize === "1") {
      return `${lang.otherFontSize.medium}`;
    }
    if (fontSize === 2 || fontSize === "2") {
      return `${lang.otherFontSize.large}`;
    }
    if (fontSize === 0 || fontSize === "0") {
      return `${lang.otherFontSize.small}`;
    }
  };

  const changeheaderFontSize = () => {
    if (fontSize === 1 || fontSize === "1") {
      return `${lang.HeaderFontSize.medium}`;
    }
    if (fontSize === 2 || fontSize === "2") {
      return `${lang.HeaderFontSize.large}`;
    }
    if (fontSize === 0 || fontSize === "0") {
      return `${lang.HeaderFontSize.small}`;
    }
  };

  const changeiconFontSize = () => {
    if (iconSize === 1 || iconSize === "1") {
      return `${lang.iconSize.medium}`;
    }
    if (iconSize === 2 || iconSize === "2") {
      return `${lang.iconSize.large}`;
    }
    if (iconSize === 0 || iconSize === "0") {
      return `${lang.iconSize.small}`;
    }
  };

  const changeImageSize = () => {
    if (imageSize === 1 || imageSize === "1") {
      return `${lang.imageSize.medium}`;
    }
    if (imageSize === 2 || imageSize === "2") {
      return `${lang.imageSize.large}`;
    }
    if (imageSize === 0 || imageSize === "0") {
      return `${lang.imageSize.small}`;
    }
  };

  const showFacebook = () => {
    if (userData.data[0].facebook !== "") {
      return (
        <span className="me-2">
          <a
            href={`https://www.facebook.com/${userData.data[0].facebook}`}
            target="_blank"
            rel="noopener noreferrer"
            alt="React Image"
          >
            <img
              src={`${lang.tempIcons.fbIcon}`}
              style={{
                background: isEditing
                  ? "#3b5998"
                  : iconsThemeDefault
                  ? linkColor
                  : "#3b5998",
                borderRadius: "50%",
              }}
              alt="mobilePhone"
              width={changeiconFontSize()}
            />
          </a>
        </span>
      );
    }
  };

  const showInstaGram = () => {
    if (userData.data[0].instagram !== "") {
      return (
        <span className="me-2">
          <a
            href={`https://www.instagram.com/${userData.data[0].instagram}`}
            target="_blank"
            rel="noopener noreferrer"
            alt="React Image"
          >
            <img
              src={`${lang.tempIcons.instaIcon}`}
              style={{
                background: isEditing
                  ? "linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)"
                  : iconsThemeDefault
                  ? linkColor
                  : "linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)",
                borderRadius: "50%",
              }}
              alt="mobilePhone"
              width={changeiconFontSize()}
            />
          </a>
        </span>
      );
    }
  };

  const showTwitter = () => {
    if (userData.data[0].twitter !== "") {
      return (
        <span className="me-2">
          <a
            href={`https://www.twitter.com/${userData.data[0].twitter}`}
            target="_blank"
            rel="noopener noreferrer"
            alt="React Image"
          >
            <img
              src={`${lang.tempIcons.twitterIcon}`}
              style={{
                background: isEditing
                  ? "#00acee"
                  : iconsThemeDefault
                  ? linkColor
                  : "#00acee",
                borderRadius: "50%",
              }}
              alt="mobilePhone"
              width={changeiconFontSize()}
            />
          </a>
        </span>
      );
    }
  };

  const showlinkedIn = () => {
    if (userData.data[0].linkedIn !== "") {
      return (
        <span className="me-2">
          <a
            href={`https://www.linkedin.com/${userData.data[0].linkedIn}`}
            target="_blank"
            rel="noopener noreferrer"
            alt="React Image"
          >
            <img
              src={`${lang.tempIcons.linkedInIcon}`}
              style={{
                background: isEditing
                  ? "#0A66C2"
                  : iconsThemeDefault
                  ? linkColor
                  : "#0A66C2",
                borderRadius: "50%",
              }}
              alt="mobilePhone"
              width={changeiconFontSize()}
            />
          </a>
        </span>
      );
    }
  };
  const showLine = () => {
    if (userData.data[0].department !== "" && userData.data[0].website !== "") {
      return (
        <span
          style={{
            display: "inline",
            borderRight: `1px solid ${isEditing ? standardColor : linkColor}`,
            margin: "0px 10px",
          }}
        ></span>
      );
    }
  };

  const showDepComName = () => {
    if (userData.data[0].department !== "" && userData.data[0].website !== "") {
      return (
        <span
          style={{
            display: "inline",
            borderRight: "1px solid silver",
            margin: "0px 10px",
          }}
        ></span>
      );
    }
  };

  const showDepTitName = () => {
    if (
      (userData.data[0].department !== "" && userData.data[0].title !== "") ||
      (userData.data[0].title !== "" && userData.data[0].companyName !== "")
    ) {
      return (
        <span
          style={{
            display: "inline",
            borderRight: "1px solid silver",
            margin: " 0px 10px",
          }}
        ></span>
      );
    }
  };

  const showMobileNumber = () => {
    if (userData.data[0].mobile_number !== "") {
      return (
        <td style={{ border: "none" }}>
          <a
            style={{ color: "black" }}
            href={`tel:${userData.data[0].mobile_number}`}
            target="_blank"
            rel="noopener noreferrer"
            alt="React Image"
          >
            <div style={{ display: "inline-block" }}>
              {/* <img
                src={`${lang.tempIcons.mobileNumberIcon}`}
                style={{ background: themeColor }}
                alt="mobilePhone"
                width="13"
              /> */}
              <span
                style={{
                  color: isEditing ? standardColor : themeColor,
                  fontWeight: "600",
                  fontSize: changeOtherFontSize(),
                }}
              >
                P:
              </span>
              <span
                className="ms-2"
                style={{
                  color: textColor,

                  fontSize: changeOtherFontSize(),
                }}
              >
                {userData.data[0].mobile_number}
              </span>
            </div>
          </a>
        </td>
      );
    }
  };

  const showWebsite = () => {
    if (userData.data[0].website !== "") {
      return (
        <a
          style={{ color: "black" }}
          href={`//${userData.data[0].website}`}
          target="_blank"
          rel="noopener noreferrer"
          alt="React Image"
        >
          <div style={{ display: "inline-block" }}>
            <strong
              style={{
                color: isEditing ? "#003e4d" : themeColor,
                fontSize: changeOtherFontSize(),
              }}
            >
              {userData.data[0].website}
            </strong>
          </div>
        </a>
      );
    }
  };

  const showAddress = () => {
    if (userData.data[0].address !== "") {
      return (
        <td style={{ border: "none" }}>
          <a
            className="text-decoration-none"
            href={`https://www.google.com/maps/search/${userData.data[0].address}`}
            target="_blank"
            rel="noopener noreferrer"
            alt="React "
            style={{ color: "black" }}
          >
            <div
              style={{
                display: "inline-block",
                maxWidth: "300px",
                width: "300px",
                wordBreak: "break-all",
              }}
            >
              {/* <img
                src={`${lang.tempIcons.addressIcon}`}
                style={{ background: themeColor }}
                alt="mobilePhone"
                width="13"
              /> */}
              <span
                style={{
                  color: isEditing ? standardColor : themeColor,
                  fontWeight: "600",
                  fontSize: changeOtherFontSize(),
                }}
              >
                A:
              </span>
              <span
                className="ms-2 text-decoration-none"
                style={{
                  color: textColor,

                  fontSize: changeOtherFontSize(),
                }}
              >
                {userData.data[0].address}
              </span>
            </div>
          </a>
        </td>
      );
    }
  };

  const showEmail = () => {
    if (userData.data[0].email !== "") {
      return (
        <td style={{ border: "none" }}>
          <a
            href={`mailto:${userData.data[0].email}`}
            target="_blank"
            rel="noopener noreferrer"
            alt="React Image"
            style={{ color: "black" }}
          >
            <div style={{ display: "inline-block" }}>
              {/* <img
                src={`${lang.tempIcons.emailIcon}`}
                style={{ background: themeColor }}
                alt="mobilePhone"
                width="13"
              /> */}
              <span
                style={{
                  color: isEditing ? standardColor : themeColor,
                  fontWeight: "600",
                  fontSize: changeOtherFontSize(),
                }}
              >
                E:
              </span>
              <span
                className="ms-2"
                style={{
                  color: textColor,

                  fontSize: changeOtherFontSize(),
                }}
              >
                {userData.data[0].email}
              </span>
            </div>
          </a>
        </td>
      );
    }
  };

  const bannerImage = () => {
    if (
      (bannerImageUrl === `${lang.staticBannerImage}` && isEditing) || //preview
      (bannerImageUrl !== `${lang.staticBannerImage}` && bannerImageUrl !== "") //user uploaded image
    ) {
      return (
        <a href={`//${bannerUrl}`} target="_blank" rel="noopener noreferrer">
          <img
            src={`${
              bannerImageUrl === `${lang.staticBannerImage}`
                ? lang.templateBannerImages.temp13
                : `${lang.imageUrl}/${bannerImageUrl}`
            }`}
            alt="noImage"
            style={{
              paddingTop: "20px",
              maxWidth: "450px",
              display: " block",
              height: `auto`,
            }}
          />
        </a>
      );
    }
  };

  useEffect(() => {
    setIsEditing(!userData.profileFormData[0].profileFormData);

    setBannerImageUrl(uploadBanner.bannerImage[0].bannerImageUrl);
    setBannerUrl(
      uploadBanner.bannerurl[0].bannerUrl !== undefined
        ? uploadBanner.bannerurl[0].bannerUrl
        : ""
    );

    setTextColor(userStyle.customTextColor[0].textColor);
    setThemeColor(userStyle.customThemeColor[0].themeColor);
    setIconsThemeDefault(userStyle.iconsThemeDefault[0].iconsThemeDefault);
    setLinkColor(userStyle.customLinkColor[0].linkColor);

    setFontSize(userStyle.customFontSize[0].fontSize);
    setTextName(userStyle.customNameColor[0].textName);
    setImageSize(userStyle.imageSize[0].imageSize);
    setImageShape(userStyle.imageShape[0].imageShape);
    setIconSize(userStyle.iconSize[0].iconSize);
    setimageUrl(userImages.image[0].imageUrl);
  }, [
    uploadBanner,
    userData,
    userImages,
    userStyle,

    bannerImageUrl,
    bannerUrl,

    textColor,
    themeColor,
    linkColor,
    fontSize,

    textname,
    imageUrl,
  ]);

  return (
    <>
      <table
        style={{
          userSelect: "none",
          border: "none",
        }}
      >
        <tbody style={{ border: "none" }}>
          <tr style={{ border: "none" }}>
            <td
              colSpan="2"
              style={{
                borderBottom: "1px solid #2f9aa3",
              }}
            >
              <strong
                style={{
                  color: isEditing ? "#003e4d" : textname,

                  fontSize: changeheaderFontSize(),
                  display: "block",
                  marginBottom: "3px",
                }}
              >
                <span>{userData.data[0].firstName}</span>
                <span>&nbsp;</span>
                <span>{userData.data[0].lastName}</span>
              </strong>

              <span
                className=" d-inline"
                style={{
                  color: isEditing ? standardColor : themeColor,

                  fontSize: changeOtherFontSize(),
                }}
              >
                {userData.data[0].department}
              </span>
              {showLine()}
              {showWebsite()}
            </td>
          </tr>

          <tr style={{ border: "none" }}>
            <td
              className="image"
              style={{
                verticalAlign: "top",
                paddingRight: "25px",
                border: "none",
                paddingTop: "30px",
              }}
            >
              <table style={{ border: "none" }}>
                <tbody style={{ border: "none" }}>
                  <tr style={{ border: "none" }}>
                    <td style={{ border: "none" }}>
                      {isAuth ? (
                        <img
                          className=""
                          src={`${
                            imageUrl !== ""
                              ? imageUrl === `${lang.staticImage}`
                                ? lang.staticImage
                                : `${lang.imageUrl}/${imageUrl}`
                              : ""
                          } `}
                          style={{
                            width: changeImageSize(),
                            height: changeImageSize(),
                            objectFit: "cover",
                            borderRadius: imageShape === "circle" ? "50%" : "",
                          }}
                          alt="React"
                        />
                      ) : (
                        <img
                          className=""
                          src={`${
                            imageUrl === `${lang.staticImage}`
                              ? lang.staticImage
                              : imageUrl
                          }`}
                          style={{
                            width: changeImageSize(),
                            height: changeImageSize(),
                            objectFit: "cover",
                            borderRadius: imageShape === "circle" ? "50%" : "",
                          }}
                          alt="React"
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td style={{ border: "none", paddingTop: "30px" }}>
              <table style={{ border: "none" }}>
                <tbody style={{ border: "none" }}>
                  <tr style={{ border: "none" }}>{showMobileNumber()}</tr>
                  <tr style={{ border: "none" }}>{showEmail()}</tr>
                  <tr style={{ border: "none" }}>{showAddress()}</tr>
                  <tr style={{ border: "none" }}>
                    <td style={{ border: "none" }}>
                      {showInstaGram()}
                      {showFacebook()}
                      {showTwitter()}
                      {showlinkedIn()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      {bannerImage()}
      <FeaturesTemplate isBanner="false" />
    </>
  );
}
